import React from 'react';
import PropTypes from 'prop-types';
import ErrorTemplateBody from './ErrorTemplateBody';

var InternalServerError500Page = React.forwardRef(function (props, ref) {
    var edsContext = props.edsContext;

    var errorTitle = edsContext.formatMessage('component.ErrorPage.500');
    var errorMessage = edsContext.formatMessage('component.ErrorPage.500.message');

    return React.createElement(ErrorTemplateBody, Object.assign({
        largeIllustrationName: props.narrow ? '500Narrow.png' : '500.png',
        errorTitle: errorTitle,
        errorMessage: errorMessage
    }, props, {
        ref: ref
    }));
});

InternalServerError500Page.propTypes = {
    edsContext: PropTypes.object,
    narrow: PropTypes.bool
};

export default InternalServerError500Page;